<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-copyright-area border-top">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-4 text-center text-md-left">
                        <span class="copyright-text">© 2023 Tous droits réservés Pied Pro.</span>
<!--                        <span id="siteseal"><script async type="text/javascript" src="https://seal.godaddy.com/getSeal?sealID=SXIg534MdibOKo2cmqh3bG6eGEuCG7uvtUH80QtVcFAOYhrjRPeZwM27Ou1L"></script></span>-->
                    </div>
                    <div class="col-md-4 footer-widget">
<!--                      <h6 class="footer-widget__title text-center pt-2" style="color:#7e7e7e;">Suivez-nous</h6>-->
<!--                      <div class="text-center">-->
<!--                        <ul class="list ht-social-networks solid-rounded-icon">-->
<!--                          <li class="item">-->
<!--                            <a href="https://www.facebook.com/centredentairelaprairie" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i> </a>-->
<!--                          </li>-->
<!--                          <li class="item">-->
<!--                            <a href="https://www.instagram.com/centredentairelaprairieinc" target="_blank" class="social-link"> <i class="fab fa-instagram social-link-icon"></i> </a>-->
<!--                          </li>-->
<!--                        </ul>-->
<!--                      </div>-->
                    </div>
                    <div class="col-md-4 text-center text-md-right">
                      <span class="copyright-text text-center">
<!--                        CRÉATION -->
                        PAR
                        <br>
                        <a href="Https://www.forswitch.com">
                          <img height="25"
                               src="@/assets/img/pied-pro/logo-h-full-forswitch.png"
                               alt="ForSwitch"
                               class="mb-2"/>
                        </a>
                      </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import TabOneDentiste from "@/components/cliniqueDentaire/TabOneDentiste";

    export default {
        name: 'FooterMain',
        props:{
            FooterStyle: {
              type: String,
              default: "FooterStyle"
            },
            isLinkPage: {
              type: Boolean,
              default: false
            }
          },
        components: {
          // TabOneDentiste
        },
        data (){
          return {
            userSelection:'',
            soinDentaireList: [
              {
                soinTitle: 'Dentisterie familiale'
              },
              {
                soinTitle: 'Restauration CEREC'
              },
              {
                soinTitle: 'Chirurgies'
              },
              {
                soinTitle: 'Esthétique dentaire'
              },
              {
                soinTitle: 'Traitement des douleurs'
              },
              {
                soinTitle: 'Prothèse amovible'
              }
            ]
          }
        },
        methods: {
          // selection of the Soins Dentaire modal.
          selection(soinSelected) {
            this.userSelection = soinSelected
          },
          scrollToTop() {
            // if the footer is not on the home page,
            // then any section clicked will be returned to main page
            if( this.isLinkPage ) {
              this.$router.push({ path: '/'})
            }
            else {
              window.scrollTo(0,0);
            }
          },
        }
    }
</script>